export default {"src":"/komodo/_next/static/media/browser.ffc95763.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};